import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import CardOrderMenuItems from '@/components/CardOrderMenu/components/CardOrderMenuItems';
import { useCardOrder } from '@/contexts/cardOrderContext';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/ui';

import './styles.css';
import type { Props } from './types';

/**
 * The page's own settings, which today is which card order it uses.
 *
 * It sits apart from the person actions in the toolbar, because it acts on
 * the page rather than on the member.
 *
 * Staff who work in more than one role pick which of their layouts to follow;
 * staff who may edit role defaults pick a role to arrange the page for. It
 * renders nothing on pages without sortable cards, and nothing for the great
 * majority of staff, who have one role and no say over its default.
 *
 * On a column too narrow for its button the toolbar hides this and puts the
 * same choices in the overflow menu instead.
 */
const CardOrderMenu = ({ className }: Props) => {
  const { controls } = useCardOrder();

  if (!controls?.isAvailable) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger aria-label="view options" className={className}>
        <Button
          color={controls.editingRole ? 'secondary' : 'neutral'}
          size="xs"
          title="View Options"
          variant={controls.editingRole ? 'default' : 'outline'}>
          <FontAwesomeIcon icon={faLayerGroup} className="mr-0 @4xl:mr-2" />
          {/* Labelled like the toolbar's other buttons once the column is wide
              enough for words, and an icon alone before that. */}
          <span className="hidden @4xl:block">View Options</span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        <CardOrderMenuItems />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default React.memo(CardOrderMenu);
